import { ClassItemCombinedProps } from './types';

const usePresenter = (props: ClassItemCombinedProps): ClassItemCombinedProps => {
  return props;
};

export default usePresenter;
